import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Unstable_Grid2";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { loginUser } from "../redux/auth";
import Notifications from "./Notifications";

const emailPattern = /^[\w.-]+@([\w-]+\.)+[\w-]{2,}$/;

const Login = ({ className }) => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [isLoginInProgress, setLoginInProgress] = useState(false);

  const submitForm = (event) => {
    event.preventDefault();
    const isValidEmail = emailPattern.test(email);
    if (!isValidEmail) {
      setEmailError("Email is required");
    }
    if (!password) {
      setPasswordError("Password is required");
    }
    if (isValidEmail && password && !isLoginInProgress) {
      setLoginInProgress(true);
      dispatch(loginUser({ email, password })).finally(() => {
        setLoginInProgress(false);
      });
    }
  };

  return (
    <Box
      alignItems="center"
      autoComplete="off"
      className={className}
      component="form"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      noValidate
      onSubmit={submitForm}
    >
      <Grid container xs={12} spacing={1}>
        <Grid className="formRow" xs={12}>
          <div className="LogoContainer">
            <Typography className="Logo">AZLedger</Typography>
          </div>
        </Grid>
        <Grid className="formRow" xs={12}>
          <TextField
            autoFocus
            className="input"
            error={!!emailError}
            helperText={emailError}
            inputProps={{ pattern: emailPattern }}
            label="Email"
            onChange={(event) => {
              setEmail(event.target.value);
              setEmailError("");
            }}
            required
            type="email"
            value={email}
          />
        </Grid>
        <Grid className="formRow" xs={12}>
          <TextField
            className="input"
            error={!!passwordError}
            helperText={passwordError}
            label="Password"
            type="password"
            required
            onChange={(event) => {
              setPassword(event.target.value);
              setPasswordError("");
            }}
            value={password}
          />
        </Grid>
        <Grid className="formRow lastRow" xs={12}>
          <Button
            className={isLoginInProgress ? "InProgress" : ""}
            disabled={isLoginInProgress}
            type="submit"
          >
            Login
          </Button>
        </Grid>
      </Grid>
      <Notifications />
    </Box>
  );
};

export default styled(Login)(
  ({ theme }) => `
  height: 100%;

  .formRow {
    text-align: center;
  }

  .formRow.lastRow {
    margin-top: 10px;
  }

  .input {
    width: 300px;
  }

  .LogoContainer {
    flex-grow: 1;
    padding: 10px;
    margin-bottom: 10px;

    background-image: linear-gradient(90deg, ${theme.palette.secondary.main} 30%, ${theme.palette.primary.main} 95%);
    background-size: 300px 5px;
    background-position: center 100%;
    background-repeat: no-repeat;
  }

  .Logo {
    background: linear-gradient(90deg, ${theme.palette.secondary.main} 30%, ${theme.palette.primary.main} 95%);
    display: inline;
    font-family: milliard-medium;
    font-size: 32px;
    font-weight: 700;
    -moz-background-clip: text;
    -moz-text-fill-color: transparent;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`,
);
